module.exports = __webpack_public_path__ + "static/00006.7d4addab.jpg";